import pic from './images/card1.png';
import pic1 from './images/card2.png';
function App() {
    return (
        <div>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Responsive Payment getway form design in Hindi</title>
        <style dangerouslySetInnerHTML={{__html: "\n        *{padding:0; margin:0; box-sizing: border-box; font-family:sans-serif;}\nheader{\n\twidth: 100vw;\n\tmin-height: 100vh;\n\tbackground: #000000;\n\tfont-size: 1.2rem;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n.container{\n\tbackground: white;\n\tmax-width: 800px;\n\tmin-height: 500px;\n\tdisplay: flex;\n\tjustify-content:space-between;\n\talign-items: flex-start;\n\tpadding: 0.5rem 1.5rem;\n}\n.left{\n\tflex-basis: 50%;\n}\n.right{\n\tflex-basis: 50%;\n}\nform{\n\tpadding: 1rem;\n}\n\nh3{\n\tmargin-top: 1rem;\n\tcolor:#00ff5e;\n\t}\n\nform input[type=\"text\"]{\n\twidth: 100%;\n\tpadding: 0.5rem 0.7rem;\n\tmargin: 0.5rem 0;\n\toutline: none;\n}\n\n#zip{\n\tdisplay: flex;\n\tmargin-top: 0.5rem;\n}\n#zip select{\n\tpadding: 0.5rem 0.7rem;\n}\n#zip input[type=\"number\"]{\n\tpadding: 0.5rem 0.7rem;\n\tmargin-left: 5px;\t\n}\ninput[type=\"submit\"]{\n\twidth: 100%;\n\tpadding: 0.7rem 1.5rem;\n\tbackground: #09ff00;\n\tcolor: white;\n\tborder: none;\n\toutline: none;\n\tmargin-top: 1rem;\n\tcursor: pointer;\n}\n\ninput[type=\"submit\"]:hover{\n\tbackground: #2c3e50;\n}\n\n\n@media only screen and (max-width: 770px){\n\t.container{\n\t\tflex-direction: column;\n\t}\n\tbody{\n\t\toverflow-x: hidden;\n\t}\n}\n\n\n    " }} />
        <header>
          <div className="container">
            <div className="left">
              <h3>BILLING ADDRESS</h3>
              <form>
                Full name
                <input type="text" name placeholder="Enter name" />
                Email
                <input type="text" name placeholder="Enter email" />
                Address
                <input type="text" name placeholder="Enter address" />
                City
                <input type="text" name placeholder="Enter City" />
                <div id="zip">
                  <label>
                    State
                    <select>
                      <option>Choose State..</option>
                      <option>Andhra Pradesh</option>
                      <option>Telengana</option>
                      <option>Karnataka</option>
                      <option>Other</option>
                    </select>
                  </label>
                  <label>
                    Zip code
                    <input type="number" name placeholder="Zip code" />
                  </label>
                </div>
              </form>
            </div>
            <div className="right">
              <h3>PAYMENT</h3>
              <form>
                Accepted Card <br />
                <img src={pic} alt="BigCo Inc. logo"/>
                <img src={pic1} alt="BigCo Inc. logo"/>
                <br /><br />
                Credit card number
                <input type="text" name placeholder="Enter card number" />
                Exp month
                <input type="text" name placeholder="Enter Month" />
                <div id="zip">
                  <label>
                    Exp year
                    <select>
                      <option>Choose Year..</option>
                      <option>2022</option>
                      <option>2023</option>
                      <option>2024</option>
                      <option>2025</option>
                    </select>
                  </label>
                  <label>
                    CVV
                    <input type="number" name placeholder="CVV" />
                  </label>
                </div>
              </form>
              <input type="submit" name defaultValue="Proceed to Checkout" />
            </div>
          </div>
        </header>
      </div>
      
    );
  }
  
  export default App;
  